import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterLink} from '@angular/router';
import { RouterModule } from '@angular/router';

import { MaintenanceModeComponent } from './maintenance-mode.component';
import { MaintenanceModeHttpService } from './maintenance-mode-http.service';
import { CoreModule } from '../core/core.module';
import { AuthenticationService } from '../core/providers/services/authentication.service';
import { MaintenanceModeService } from './maintenance-mode.service';

@NgModule({
  declarations: [
    MaintenanceModeComponent,
  ],
  imports: [
    CommonModule,
    CoreModule,
    RouterModule,
    RouterLink,
  ],
  providers: [
    MaintenanceModeHttpService,
    AuthenticationService,
    MaintenanceModeService
  ],
  exports: [
    MaintenanceModeComponent,
  ]
})
export class MaintenanceModeModule { }
